module.exports = __webpack_public_path__ + "img/home_swiper_02_mobile.0b25c2d4.jpg";